import { styled } from "goober";
import { Button } from "./Button";
import { CodeBlock } from "./CodeBlock";
import { SoftButton } from "./SoftButton";
import { Text } from "./Text";
import { Tooltip } from "./Tooltip";

const PreviewArea = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Actions = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// The selected run's output and a pin button, shown once a run is chosen in the
// step-test picker. Pairs with useStepTestPin.
export function StepTestPinPreview({
  output,
  canPin,
  pinTooltip,
  onPin,
  onCancel,
}: {
  output: { loading: boolean; content: string | undefined };
  canPin: boolean;
  pinTooltip: string;
  onPin: () => void;
  onCancel: () => void;
}) {
  return (
    <PreviewArea>
      {output.loading ? (
        <Text variant="text-small" color="var(--text-secondary)">
          Loading…
        </Text>
      ) : output.content !== undefined ? (
        <CodeBlock content={output.content} wrap />
      ) : (
        <Text variant="text-small" color="var(--text-secondary)">
          This run’s output can’t be previewed (not text, JSON, or HTTP).
        </Text>
      )}
      <Actions>
        <Tooltip content={pinTooltip}>
          <SoftButton variant="secondary" disabled={!canPin} onClick={onPin}>
            Pin as step test
          </SoftButton>
        </Tooltip>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </Actions>
    </PreviewArea>
  );
}
